import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  container: {
    display: "flex",
    gap: "16px",
    flexDirection: "column",
    marginBottom: "24px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  kpiContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  cardStyle: {
    padding: "20px",
    flex: "1",
    minWidth: "200px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
  aedIcon: {
    verticalAlign: "super",
    fill: theme.palette.text.tertiary,
  },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    lineHeight: "20px",
  },
  subTitle: {
    fontSize: "30px",
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: "38px",
  },
  iconContainer: {
    padding: "10px",
    borderRadius: "10px",
    backgroundColor: theme.palette.background.secondary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  expandedRoot: {
    backgroundColor: theme.palette.background.gray_50 + "!important",
    borderRadius: "unset !important",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  filtersContainer: {
    display: "flex",
    gap: "12px",
    marginBottom: "24px",
    flexWrap: "wrap",
    alignItems: "center",
  },
  tableContainer: {
    marginBottom: "32px",
  },
  tableTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: "16px",
  },
  statusChip: {
    padding: "2px 8px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 500,
  },
  paidStatus: {
    backgroundColor: theme.palette.text.success_secondary,
    color: theme.palette.text.success_primary,
  },
  pendingStatus: {
    backgroundColor: theme.palette.text.warning_secondary,
    color: theme.palette.text.warning_primary,
  },
  controlsContainer: {
    display: "flex",
    gap: "12px",
    marginBottom: "24px",
  },
  filterWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  filtersButtons: {
    alignSelf: "flex-end",
  },
  filtersContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    width: "100%",
    flex: 2,
    maxWidth: "1000px",
    marginTop: "16px",
    "& .input-wrapper": {
      maxWidth: "191px",
    },
    [theme.breakpoints.down("1500")]: {
      minWidth: "initial",
    },
    [theme.breakpoints.down("1345")]: {
      "& .input-wrapper": {
        maxWidth: "190px",
      },
    },
    [theme.breakpoints.down("780")]: {
      "& .input-wrapper": {
        maxWidth: "190px",
      },
    },
    [theme.breakpoints.down("420")]: {
      "& .input-wrapper": {
        maxWidth: "165px",
      },
    },
  },
  inputwrapper: {
    width: "100% !important",
    maxWidth: "191px",
  },
  autoCompleteInput: {
    minWidth: "190px",
    [theme.breakpoints.down("420")]: {
      maxWidth: "165px",
      width: "100% !important",
      minWidth: "initial",
    },
  },
  autoCompleteMedia: {
    // minWidth: "291px",
    [theme.breakpoints.down("1345")]: {
      width: "100%",
      minWidth: "initial",
      maxWidth: "190px",
    },
    [theme.breakpoints.down("420")]: {
      maxWidth: "165px",
      width: "100% !important",
      minWidth: "initial",
    },
  },
  searchInput: {
    maxWidth: "191px",
    width: "100% !important",
  },
  searchInputContainer: {
    display: "flex",
    gap: "12px",
  },
  dateFilter: {
    width: "165px",
    marginLeft: "auto",
    padding: "10px 16px",
    fontSize: "16px",
    fontWeight: 600,
    background: theme.palette.background.paper,
    borderRadius: "8px",
    border: `1px solid ${theme.palette.foreground.senary}`,
    alignSelf: "flex-start",
    textAlign: "center",
    [theme.breakpoints.down("780")]: {
      marginLeft: "0",
    },
  },
  dateFilterContainer: {
    display: "flex",
    alignSelf: "flex-start",
    width: "100%",
    marginTop: "16px",
    gap: "12px",
    flex: 1,
    [theme.breakpoints.down("780")]: {
      "& > *": {
        width: "190px",
      },
    },
    [theme.breakpoints.down("420")]: {
      "& > *": {
        width: "165px",
      },
    },
  },
  filterSection: {
    display: "flex",
    [theme.breakpoints.down("780")]: {
      flexDirection: "column",
      maxWidth: "500px",
      width: "100%",
    },
  },
  noDataWrapper: {
    maxWidth: "480px",
    width: "100%",
  },
  actionsContainer: {
    display: "flex",
    gap: "16px",
    marginTop: "24px",
  },
}));
